//import style global sheet
import './style/App.css';
import './style/Font.css';
import './style/Scrollbar.scss';
import './style/TextFieldStyle.css'
import './style/CustomizeComponents.css'
import './style/FlexStyle.css'
import './style/TableStyle.scss'
import "./style/Containers.css"
import "./style/ModalStyleSheet.css"
import "./style/CardStyleSheet.scss"
import "./style/Icons.css"
import "./style/SelectionStyleSheet.css"

//import library
import {ThemeProvider} from '@mui/material';
import {Navigate, Route, Routes} from "react-router-dom";
import CustomTheme from "./theme/CustomTheme";
import Login from "./pages/login/Login";
import PrivateRoute from "./route/PrivateRoute";
import React from "react";
import ForgetPassword from "./pages/forgetPassword/ForgetPassword";
import ConfirmPhoneNumber from "./pages/confirmPhoneNumber/ConfirmPhoneNumber";
import {RouteInfo} from "./route/RouteHelper";

import {prefixer} from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import {CacheProvider} from "@emotion/react";
import {ThemeColor} from "./component/ThemeToggle/ThemeColorToggle";
import {PwaInstallPrompt} from "./component/pwaInstallPrompt/PwaInstallPrompt";


const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin]
});

function App() {

    const body = document.body
    const lightTheme = "light"
    const darkTheme = "dark"

    let theme;
    let themeColor = ""

    if (localStorage) {
        theme = localStorage.getItem("theme")
        themeColor = localStorage.getItem("themeColor");
    }

    if (theme === lightTheme || theme === darkTheme) {
        body.classList.add(theme)
    } else {
        theme = lightTheme
        body.classList.add(lightTheme)
    }

    if (themeColor && themeColor.length > 0) {
        body.classList.add(themeColor);
    } else {
        themeColor = ThemeColor.Purple;
        body.classList.add(themeColor);
    }

    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={CustomTheme}>

                <Routes>
                    <Route element={<Login/>} path={RouteInfo.Login.url}/>
                    <Route element={<ForgetPassword/>} path={RouteInfo.ForgetPassword.url}/>
                    <Route element={<ConfirmPhoneNumber/>} path={RouteInfo.ConfirmPhoneNumber.url}/>

                    {/*<Route element={ <SuperAdmin/>} path={RouteInfo.Root.url}/>*/}
                    <Route
                        path='/panel/*'
                        element={
                            <PrivateRoute/>
                        }
                    />
                    <Route path="*" element={<Navigate replace to="/panel/"/>}/>
                </Routes>
                <PwaInstallPrompt/>
            </ThemeProvider>
        </CacheProvider>
    );
}

export default App;
